import { render, staticRenderFns } from "./city.vue?vue&type=template&id=1a0bafcc&scoped=true&"
var script = {}
import style0 from "./city.vue?vue&type=style&index=0&id=1a0bafcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0bafcc",
  null
  
)

export default component.exports